var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrapes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 504.115 504.115",
    style: {
      enableBackground: "new 0 0 504.115 504.115"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11A569"
    },
    d: "M288.465,36.399c0,20.11-16.297,99.785-36.407,99.785S215.65,56.509,215.65,36.399 S231.948,0,252.058,0C272.167,0,288.465,16.289,288.465,36.399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#048950"
    },
    d: "M252.058,0c20.11,0,36.407,16.289,36.407,36.399s-16.297,99.785-36.407,99.785"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7746BC"
    },
    cx: 156.195,
    cy: 207.21,
    r: 61.991
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C339E"
    },
    d: "M200.031,163.367c24.214,24.214,24.214,63.464,0.008,87.694 c-24.214,24.198-63.464,24.198-87.678-0.016c-24.222-24.214,25.309-13.942,49.514-38.156 C186.088,188.676,175.817,139.154,200.031,163.367z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9F84D3"
    },
    d: "M147.302,159.909c5.096,5.104-7.916,9.295-18.527,19.889 c-10.602,10.602-14.793,23.631-19.889,18.527c-5.104-5.12-0.638-17.865,9.956-28.459 C129.445,159.264,142.182,154.797,147.302,159.909z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 161.867,
    cy: 156.609,
    r: 3.82
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 108.847,
    cy: 209.124,
    r: 1.528
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7746BC"
    },
    cx: 347.928,
    cy: 207.21,
    r: 61.999
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C339E"
    },
    d: "M304.085,163.367c-24.214,24.214-24.214,63.464-0.008,87.694 c24.214,24.198,63.464,24.198,87.686-0.016c24.214-24.214-25.316-13.942-49.53-38.156 C318.035,188.676,328.298,139.154,304.085,163.367z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9F84D3"
    },
    d: "M356.813,159.909c-5.089,5.104,7.908,9.295,18.527,19.889 c10.602,10.602,14.793,23.631,19.889,18.527c5.104-5.12,0.646-17.865-9.956-28.459C374.67,159.271,361.933,154.797,356.813,159.909 z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 342.241,
    cy: 156.609,
    r: 3.82
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 395.268,
    cy: 209.124,
    r: 1.528
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7746BC"
    },
    cx: 252.058,
    cy: 163.588,
    r: 61.991
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C339E"
    },
    d: "M314.041,163.588c0,34.249-27.735,61.999-61.984,61.999s-61.991-27.75-61.991-61.999 s27.743,8.042,61.991,8.042S314.041,129.339,314.041,163.588z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9F84D3"
    },
    d: "M279.217,123.849c0,7.215-12.162,0.985-27.16,0.985s-27.152,6.231-27.152-0.985 c0-7.231,12.154-13.076,27.152-13.076C267.055,110.773,279.217,116.618,279.217,123.849z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 291.868,
    cy: 131.828,
    r: 3.82
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 217.242,
    cy: 131.442,
    r: 1.536
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7746BC"
    },
    cx: 165.388,
    cy: 286.633,
    r: 56.052
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C339E"
    },
    d: "M205.024,246.997c21.882,21.89,21.882,57.383,0,79.273c-21.898,21.874-57.376,21.874-79.273-0.016 c-21.906-21.874,22.875-12.603,44.788-34.477C192.414,269.879,183.127,225.091,205.024,246.997z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9F84D3"
    },
    d: "M157.338,243.862c4.616,4.616-7.144,8.413-16.731,17.999c-9.578,9.586-13.375,21.339-17.983,16.723 c-4.616-4.616-0.583-16.124,9.003-25.71C141.214,243.287,152.706,239.246,157.338,243.862z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 170.531,
    cy: 240.868,
    r: 3.458
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 122.561,
    cy: 288.366,
    r: 1.386
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7746BC"
    },
    cx: 338.735,
    cy: 286.633,
    r: 56.044
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C339E"
    },
    d: "M299.106,246.997c-21.898,21.89-21.898,57.383-0.008,79.273 c21.882,21.874,57.383,21.874,79.265-0.016c21.906-21.874-22.875-12.603-44.78-34.477 C311.702,269.879,320.981,225.091,299.106,246.997z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9F84D3"
    },
    d: "M346.778,243.862c-4.616,4.616,7.152,8.413,16.731,17.999c9.578,9.586,13.367,21.339,17.991,16.723 c4.616-4.616,0.575-16.124-9.011-25.71C362.917,243.295,351.393,239.246,346.778,243.862z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 333.592,
    cy: 240.868,
    r: 3.458
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 381.538,
    cy: 288.366,
    r: 1.386
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7746BC"
    },
    cx: 252.058,
    cy: 247.186,
    r: 56.06
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C339E"
    },
    d: "M308.118,247.186c0,30.972-25.112,56.06-56.06,56.06s-56.06-25.096-56.06-56.06 c0-30.956,25.112,7.263,56.06,7.263S308.118,216.229,308.118,247.186z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9F84D3"
    },
    d: "M276.61,211.275c0,6.506-10.996,0.874-24.552,0.874s-24.552,5.632-24.552-0.874 c0-6.554,10.996-11.831,24.552-11.831S276.61,204.721,276.61,211.275z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 288.055,
    cy: 218.498,
    r: 3.458
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 220.581,
    cy: 218.104,
    r: 1.386
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7746BC"
    },
    cx: 171.965,
    cy: 365.505,
    r: 51.807
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C339E"
    },
    d: "M208.593,328.877c20.212,20.228,20.212,53.027,0,73.263c-20.236,20.228-53.035,20.228-73.271,0 s21.142-11.658,41.385-31.878C196.935,350.027,188.357,308.634,208.593,328.877z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9F84D3"
    },
    d: "M164.521,325.971c4.261,4.277-6.624,7.782-15.462,16.628c-8.869,8.862-12.359,19.724-16.62,15.478 c-4.285-4.293-0.544-14.927,8.31-23.773C149.61,325.443,160.244,321.709,164.521,325.971z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 176.691,
    cy: 323.222,
    r: 3.19
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 132.399,
    cy: 367.057,
    r: 1.284
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7746BC"
    },
    cx: 332.174,
    cy: 365.505,
    r: 51.799
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C339E"
    },
    d: "M295.546,328.877c-20.244,20.228-20.244,53.027-0.024,73.263c20.236,20.228,53.035,20.228,73.279,0 c20.228-20.228-21.165-11.658-41.385-31.878C307.18,350.027,315.766,308.634,295.546,328.877z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9F84D3"
    },
    d: "M339.602,325.971c-4.269,4.277,6.609,7.782,15.47,16.628c8.862,8.862,12.359,19.724,16.62,15.478 c4.269-4.293,0.528-14.927-8.326-23.773C354.521,325.443,343.879,321.709,339.602,325.971z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 327.44,
    cy: 323.222,
    r: 3.19
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 371.732,
    cy: 367.057,
    r: 1.292
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7746BC"
    },
    d: "M303.864,329.058c0,28.601-23.19,51.783-51.807,51.783c-28.609,0-51.799-23.182-51.799-51.783 c0-28.633,23.19-51.814,51.799-51.814C280.674,277.244,303.864,300.434,303.864,329.058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C339E"
    },
    d: "M303.864,329.058c0,28.601-23.19,51.783-51.807,51.783c-28.609,0-51.799-23.182-51.799-51.783 c0-28.633,23.19,6.711,51.799,6.711C280.674,335.77,303.864,300.434,303.864,329.058z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9F84D3"
    },
    d: "M274.759,295.849c0,6.034-10.161,0.819-22.701,0.819c-12.54,0-22.693,5.215-22.693-0.819 c0-6.049,10.153-10.925,22.693-10.925C264.598,284.924,274.759,289.8,274.759,295.849z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 285.314,
    cy: 302.505,
    r: 3.198
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 222.968,
    cy: 302.182,
    r: 1.284
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7746BC"
    },
    cx: 190.996,
    cy: 427.181,
    r: 39.463
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C339E"
    },
    d: "M218.927,399.258c15.407,15.431,15.407,40.432,0,55.847c-15.439,15.431-40.432,15.431-55.871,0 c-15.423-15.415,16.124-8.877,31.563-24.308C210.042,415.382,203.488,383.827,218.927,399.258z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9F84D3"
    },
    d: "M185.324,397.044c3.253,3.261-5.057,5.939-11.784,12.674c-6.758,6.751-9.421,15.045-12.682,11.8 c-3.245-3.261-0.417-11.366,6.357-18.125C173.966,396.642,182.063,393.783,185.324,397.044z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 194.635,
    cy: 394.957,
    r: 2.434
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9F84D3"
    },
    d: "M161.536,427.709c0.37,0.37,0.37,1,0,1.386c-0.394,0.37-1.024,0.37-1.394-0.016 c-0.378-0.37-0.378-1,0-1.371C160.512,427.307,161.142,427.307,161.536,427.709z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7746BC"
    },
    cx: 313.104,
    cy: 427.181,
    r: 39.463
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C339E"
    },
    d: "M285.212,399.258c-15.431,15.431-15.431,40.432-0.016,55.847c15.423,15.431,40.424,15.431,55.855,0 c15.431-15.415-16.132-8.877-31.547-24.308C294.073,415.382,300.619,383.827,285.212,399.258z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9F84D3"
    },
    d: "M318.791,397.044c-3.245,3.261,5.049,5.939,11.792,12.674c6.758,6.751,9.413,15.045,12.674,11.8 c3.253-3.261,0.41-11.366-6.341-18.125C330.157,396.642,322.06,393.783,318.791,397.044z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 309.504,
    cy: 394.957,
    r: 2.434
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9F84D3"
    },
    d: "M342.587,427.709c-0.37,0.37-0.37,1,0,1.386c0.402,0.37,1.016,0.37,1.394-0.016 c0.37-0.37,0.37-1,0-1.371C343.603,427.307,342.989,427.307,342.587,427.709z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7746BC"
    },
    cx: 252.058,
    cy: 399.431,
    r: 39.463
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C339E"
    },
    d: "M291.552,399.399c0,21.819-17.676,39.479-39.495,39.479c-21.811,0-39.495-17.66-39.495-39.479 c0-21.819,17.684,5.104,39.495,5.104C273.877,404.504,291.552,377.588,291.552,399.399z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9F84D3"
    },
    d: "M269.355,374.075c0,4.6-7.735,0.63-17.298,0.63c-9.57,0-17.306,3.97-17.306-0.63 c0-4.6,7.735-8.326,17.306-8.326C261.62,365.757,269.355,369.475,269.355,374.075z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 277.413,
    cy: 379.156,
    r: 2.442
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 229.884,
    cy: 378.919,
    r: 0.985
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7746BC"
    },
    cx: 252.058,
    cy: 464.652,
    r: 39.463
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C339E"
    },
    d: "M291.552,464.628c0,21.819-17.676,39.479-39.495,39.479c-21.811,0-39.495-17.66-39.495-39.479 c0-21.819,17.684,5.104,39.495,5.104C273.877,469.74,291.552,442.817,291.552,464.628z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9F84D3"
    },
    d: "M269.355,439.32c0,4.6-7.735,0.614-17.298,0.614c-9.57,0-17.306,3.986-17.306-0.614 c0-4.616,7.735-8.342,17.306-8.342C261.62,430.986,269.355,434.704,269.355,439.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9F84D3"
    },
    d: "M279.847,444.384c0,1.355-1.087,2.458-2.45,2.458c-1.331,0-2.434-1.111-2.434-2.458 c0-1.323,1.103-2.434,2.434-2.434C278.768,441.951,279.847,443.061,279.847,444.384z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9F84D3"
    },
    cx: 229.884,
    cy: 444.156,
    r: 0.985
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#048950"
    },
    d: "M203.78,85.693c0,0-45.781-39.337-88.505-16.573c0,0,14.344,0.662,18.046,13.785 c3.718,13.123,11.335,13.265,11.335,13.265s-11.957-8.121-23.213,14.848c-11.232,22.985-44.82,29.601-44.82,29.601 s64.528,29.554,90.167,12.642c0,0-1.441,12.493,7.089,21.48c0,0,12.753-19.259,27.152-27.813c14.391-8.57,19.054-25.08,20.48-37.573 c0,0-23.008-16.644-82.211,12.296c0,0,33.256-29.491,81.353-23.048L203.78,85.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11A569"
    },
    d: "M218.352,107.741c-8.034-3.356-32.154-9.019-79.045,13.911c0,0,33.256-29.491,81.353-23.048 l-16.88-12.91c0,0-45.781-39.337-88.505-16.573c0,0,14.344,0.662,18.046,13.785c2.087,7.373,5.372,10.571,7.885,12.028 c-4.364-0.74-12.217,0.677-19.763,16.077c-11.232,22.985-44.82,29.601-44.82,29.601s1.15,0.52,3.127,1.355 c11.406,2.387,23.528,3.663,36.092,3.663C159.023,145.629,196.84,130.473,218.352,107.741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#048950"
    },
    d: "M300.335,85.693c0,0,45.781-39.337,88.505-16.573c0,0-14.344,0.662-18.046,13.785 c-3.718,13.123-11.343,13.265-11.343,13.265s11.965-8.121,23.213,14.848c11.24,22.985,44.828,29.601,44.828,29.601 s-64.536,29.554-90.167,12.642c0,0,1.441,12.493-7.089,21.48c0,0-12.753-19.259-27.152-27.813 c-14.391-8.57-19.054-25.08-20.48-37.573c0,0,23.009-16.644,82.211,12.296c0,0-33.256-29.491-81.353-23.048L300.335,85.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11A569"
    },
    d: "M285.763,107.741c8.027-3.356,32.154-9.019,79.045,13.911c0,0-33.256-29.491-81.353-23.048 l16.88-12.91c0,0,45.781-39.337,88.505-16.573c0,0-14.344,0.662-18.046,13.785c-2.087,7.373-5.372,10.571-7.885,12.028 c4.364-0.74,12.217,0.677,19.755,16.077c11.24,22.985,44.828,29.601,44.828,29.601s-1.15,0.52-3.127,1.355 c-11.406,2.387-23.536,3.663-36.092,3.663C345.092,145.629,307.275,130.473,285.763,107.741z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrapes);
export default __webpack_public_path__ + "static/media/grapes.67e70bf58fec54b2c287d3d06f9b1ca3.svg";
export { ForwardRef as ReactComponent };